<template>
  <div class="app-error d-flex flex-justify-between">
    <div class="error-message"><slot></slot></div>
    <close-button @close="closeClicked"></close-button>
  </div>
</template>
<script>
import CloseButton from "@/components/common/buttons/CloseButton.vue";
export default {
  components: { CloseButton },
  methods: {
    closeClicked: function() {
      this.$store.commit("clearError");
    },
  },
};
</script>
